export const dataChart = [
    {
      name: 'Jan',
      "Active User": 3000,
    },
    {
        name: 'Feb',
        "Active User": 5000,
    },
    {
        name: 'Mar',
        "Active User": 4000,
    },
    {
        name: 'Apr',
        "Active User": 3000,
    },
    {
        name: 'May',
        "Active User": 2000,
    },
    {
        name: 'Jun',
        "Active User": 4000,
    },
    {
        name: 'Jul',
        "Active User": 4000,
    },
    {
        name: 'Agu',
        "Active User": 3000,
    },
    {
        name: 'Sep',
        "Active User": 4000,
    },
    {
        name: 'Oct',
        "Active User": 1000,
    },
    {
        name: 'Nov',
        "Active User": 4000,
    },
    {
        name: 'Dec',
        "Active User": 3000,
    },   
];

export const productData = [
    {
      name: 'Jan',
      "Sales": 3000,
    },
    {
        name: 'Feb',
        "Sales": 5000,
    },
    {
        name: 'Mar',
        "Sales": 4000,
    }
];